module.exports = __webpack_public_path__ + "static/media/Birth stone_mobile.jpg";